export enum MapStyle {
  NATURAL = "natural",
  BLUE = "blue",
  TERRAIN = "terrain",
  SATELLITE = "satellite",
  LIGHT = "light",
  DARK = "dark",
  GREY = "grey",
  LOVE = "love",
  FOREST = "forest",
  WOOD = "wood",
  CARTOON = "cartoon",
  DARK_GREEN = "dark-green",
  PINK = "pink",
  YELLOW = "yellow",
  MAGENTA = "magenta",
  DARK_RED = "dark-red",
  ORANGE = "orange",
  RED = "red",
  TEAL = "teal",
  BEIGE = "beige",
  GREEN = "green",
  PURPLE = "purple",
  DARK_CYAN = "dark-cyan",
  DARK_TURQUOISE = "dark-turquoise"
}

export enum StyleTier {
  FREE = "free",
  STANDARD = "standard", 
  PREMIUM = "premium",
  PRO = "pro"
}

export enum Links {
  Home = "/",
  Create = "/create",
  Checkout = "/checkout",
  Preview = "/preview",
  Map = "/map",
  PaymentFailed = "/payment-failed"
};

export enum Currency {
  USD = "USD",
  AUD = "AUD",
  MXN = "MXN", // Mexican Peso
  EUR = "EUR", // Euro
  GBP = "GBP", // British Pound
  BRL = "BRL", // Brazilian Real
  INR = "INR", // Indian Rupee
  BDT = "BDT", // Bangladeshi Tikka
}

export enum PaperOrientation {
  PORTRAIT = "pt",
  LANDSCAPE = "ls",
  SQUARE = "sq"
}

export enum ImageSize {
  SINGLE = "single",     // A4
  A4 = "a4",            // A3
  A3 = "a3",
  A2 = "a2",
  A1 = "a1",
  A0 = "a0",
  SINGLE_LS = "singlels",
  A4LS = "a4ls",
  A3LS = "a3ls",
  A2LS = "a2ls",
  A1LS = "a1ls",
  A0LS = "a0ls",
  SINGLE_SQ = "singlesq",
  A4SQ = "a4sq",
  A3SQ = "a3sq",
  A2SQ = "a2sq",
  A1SQ = "a1sq",
  A0SQ = "a0sq"
}

export interface Pin {
  lat: number;      // -180 to 180
  lng: number;      // -180 to 180
  label?: string;   // Optional label
}

export interface PathPoint {
  lat: number;      // -180 to 180
  lng: number;      // -180 to 180
}

export enum TextureFilter {
  NONE = "none"
}

export enum BorderFilter {
  NONE = "none",
  SIMPLE = "simple",
  TRANSPARENT = "transparent",
  FANCY = "fancy"
}
